import React, {useEffect, useState} from 'react'
import {Box, CircularProgress} from '@mui/material'
import {useCookies} from 'react-cookie'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import {STATUS} from 'src/constants/constants'
import apiClient from 'src/services/apiClient'
import {buildPortalUrl} from 'src/utils/portalUrl'
import EmptyState from 'src/components-new/layout/EmptyState'
import InlineMessage from 'src/components-new/feedback/InlineMessage'
import ProgramCard from './ProgramCard'
import {Program} from './types'

export default function ChangePortalNew(): JSX.Element {
  const [programs, setPrograms] = useState<Program[]>([])
  const [status, setStatus] = useState<string>()
  const [cookies] = useCookies(['tokens'])

  useEffect(() => {
    const fetchPrograms = async () => {
      const response = await apiClient.getPrograms(setStatus)
      setPrograms(response ?? [])
    }
    fetchPrograms()
  }, [])

  const buildHref = (program: Program): string =>
    cookies.tokens
      ? buildPortalUrl(program.url, {cookies: cookies.tokens, scope: program.scope})
      : buildPortalUrl(program.url)

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
      {status === STATUS.REJECTED && (
        <InlineMessage severity="error" onClose={() => setStatus(undefined)}>
          Errore nel recupero delle informazioni sui portali.
        </InlineMessage>
      )}

      {status === STATUS.PENDING ? (
        <Box sx={{display: 'flex', justifyContent: 'center', py: 6}}>
          <CircularProgress size={32} />
        </Box>
      ) : programs.length === 0 ? (
        status !== STATUS.REJECTED && (
          <EmptyState
            icon={<SwapHorizIcon sx={{fontSize: 40}} />}
            title="Nessun portale disponibile"
            description="Non sono presenti altri portali a cui accedere."
          />
        )
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)'},
            gap: 3,
          }}
        >
          {programs.map(program => (
            <ProgramCard key={program.name} program={program} href={buildHref(program)} />
          ))}
        </Box>
      )}
    </Box>
  )
}
